import { Link } from "react-router-dom"

import urbanekaText from "assets/images/urbaneka-text.svg";
import urbanekaLogo from "assets/images/urbaneka-logo.svg";
import footerBanner from "assets/images/footer-banner.jpg";

import useMobile from "hooks/useMobile";

const Footer = ()=>{
    const isMobile = useMobile();

    return <footer className="relative" >
      <div className="relative h-80">
        <div className="absolute h-full w-full text-center flex items-center justify-center text-white z-[1] flex-col gap-y-6">
          <h4 className="text-white text-2xl md:text-4xl xl:text-5xl font-semibold">Jangan ragu untuk menghubungi kami</h4>
          <a className="px-4 py-2 border-white border-2 font-semibold rounded-lg block">Contact Us</a>
        </div>
        <div className="absolute top-0 left-0 bg-black opacity-40 w-full h-full"></div>
        <img src={footerBanner} className="z-[-2] object-cover h-full w-full object-bottom" alt="" />
        <div className="absolute bottom-0 left-0 w-full h-1/6 bg-gradient-to-b from-[#00000000] to-[#000]"></div>
      </div>
      <div className="bg-black py-5 pt-10 2xl:pt-14 pb-10 lg:pb-0">
        <div className="text-gray-100 container mx-auto px-16">
          <div className="grid grid-cols-2 place-content-center xl:place-content-start xl:grid-cols-[repeat(13,minmax(0,1fr))] gap-12 mb-10">
            <div className=" flex flex-col justify-center xl:justify-start col-span-2 xl:col-span-3 place-items-center xl:place-items-start gap-y-2">
              <h3 className=" font-bold tracking-wide text-4xl mb-2 flex items-center gap-x-2">
                <img src={urbanekaLogo} className="h-8" alt="" />
                <img src={urbanekaText} className="h-8" alt="" />
              </h3>
              <p className="text-xs text-gray-200 text-center xl:text-left box-border xl:mr-5"> 
              PT Urbaneka Wawasan Teknologi <br/>
                Karya-karya Anak Bangsa <br/>
                Jalan Jatirogo, RT. 1/RW. 1, Sadang, Blandong, Paseyan, Kec. Jatirogo, Kabupaten Tuban, Jawa Timur 62362
              </p>
            </div>
            <div className="col-span-2 xl:col-span-6 relative mb-10 xl:mb-0">
            <iframe className="xl:absolute bottom-0 left-0 rounded-lg invert-[90%] hue-rotate-180" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d856.9574116270741!2d111.65125374091522!3d-6.880565245806356!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e771339118cd8ab%3A0xea4e8f34686f5b7b!2sJ%26T%20CARGO%20JATIROGO!5e0!3m2!1sen!2sid!4v1665303416242!5m2!1sen!2sid" 
                // @ts-ignore
                width="95%" height="100%" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <div className="text-center xl:text-left  mt-2 text-sm flex flex-col space-y-3 col-span-2 xl:col-span-2 font-semibold">
              <Link to="/">Home</Link>
              <Link to="/blogs">Blog</Link>
              <Link to="/events">Event</Link>
              <Link to="/job-posts">Career</Link>
              {/* <a href="https://forms.gle/HYFBjxhXSU8azoPB7">
                  Join
              </a> */}
            </div>
            {/* <div className="text-center xl:text-left mt-2 text-sm space-y-3 flex flex-col col-span-2 sm:col-span-1 xl:col-span-2 ">
              <a className=" pointer-events-none">Social Media</a>
              <div className="space-x-2 my-2">
                <a href="https://www.instagram.com/otinesia/">
                  <i className="bi text-2xl bi-instagram"></i>
                </a>
                <a className=" pointer-events-none" href="">
                  <i className="bi text-2xl bi-facebook"></i>
                </a>
                <a className=" pointer-events-none" href="">
                  <i className="bi text-2xl bi-linkedin"></i>
                </a>
              </div>
            </div> */}
          </div>
          <hr className=""/>
          <div className="text-center  text-xs py-5">
            Copyright&copy;2022 Urbaneka
          </div>
        </div>
      </div>
    </footer>
}

export default Footer;